import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import { v4 as uuidv4 } from "uuid";
import Asidebar from "../Header/Asidebar";
import { InfinitySpin } from "react-loader-spinner";
import { getData, postData } from "../../FetchNodeServices";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { useSelector } from "react-redux";
import AlertMessages from "../Mains/Alerts";

const AddPanelUser = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setFullwidthwrapper] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const myUUID = uuidv4();
  const [questions, setQuestions] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [countryId, setCountryId] = React.useState("");
  const [stateId, setStateId] = React.useState("");
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [dob, setDob] = useState("");
  const [age, setAge] = useState("");

  let navigate = useNavigate();
  // const userId = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).userId;
  const customer = useSelector((state) => state.user.users[0]);
  const client = useSelector((state) => state.subuser.subusers[0]) || null;
  const user = customer.userId;

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const calculateAge = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (months < 0) {
      years--;
      months += 12;
    }
    if (days < 0) {
      months--;
      days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
    }

    return { years, months, days };
  };

  const handleDobChange = (e) => {
    const newDob = e.target.value;
    setDob(newDob);
    const { years, months, days } = calculateAge(newDob);
    setAge(`${years} year(s), ${months} month(s), ${days} day(s)`);
  };

  const handleCountryChange = (selectedOption) => {
    setCountryId(selectedOption.value);
    // fetchState(selectedOption.value);
    // alert(selectedOption.value);
  };

  const fetchCountry = async () => {
    setIsLoading(true);
    let result = await getData("users/country");
    setCountryList(result || []);

    setIsLoading(false);
  };

  useEffect(() => {
    fetchCountry();
  }, []);

  const fillCountry = () => {
    return countryList.map((item) => {
      return { value: item.countryId, label: item.countryName };
    });
  };

  const fetchState = async (countryId) => {
    setIsLoading(true);
    let result = await getData("users/country/state-list/" + countryId);
    setStateList(result || []);
    setIsLoading(false);
  };

  useEffect(() => {
    if (countryId) {
      fetchState(countryId);
    }
  }, [countryId]);

  const fillState = () => {
    // if (stateList.length !== 0) {
    if (!Array.isArray(stateList)) {
      return [];
    }

    return stateList.map((item) => {
      return { value: item.stateId, label: item.stateName };
    });
    // }
  };



  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      const result = await getData("users/question-list?userId=" + user);
      setQuestions(result || []);
      setIsLoading(false);
      setAlerts([{ variant: "success", heading: "Data fetched successfully." }]);
    } catch (error) {
      console.error("Error fetching questions: ", error);
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const userResponses = collectUserResponses();
      console.log("test", userResponses);
      if (userResponses.length > 0) {
        const result = await postData(`users/add-panel-user-question-answer?datasource=${client}`, userResponses);
        console.log("Response from API:", result);
        setIsLoading(false);
        navigate("/panel-management");
        clearFormFields();
      } else {
        console.log("No answers to submit.");
      }
    } catch (error) {
      console.error("Error submitting questions: ", error);
    }
  };

  const collectUserResponses = () => {
    setIsLoading(true);
    const userResponses = [];
    questions.forEach((question) => {
      const answerElement = document.getElementById(question.questionId);
      let userResponse;
      let answerId;
      let openEndAnswer;
      switch (question.questionType) {
        //  "Open End Text"
        case 15:
          if (answerElement) {
            userResponse = answerElement.value;

            if (userResponse) {
              answerId = "";
              openEndAnswer = userResponse;
              userResponses.push(createResponse(question, answerId, openEndAnswer));
            }
          }
          break;
        // "Single Select" 
        case 12:
          const selectedRadio = document.querySelector(`input[name="${question.questionId}"]:checked`);
          if (selectedRadio) {
            answerId = selectedRadio.value;
            openEndAnswer = "";
            userResponses.push(createResponse(question, answerId, openEndAnswer));
          }
          break;
        // "DropDown Menu"
        case 14:
          userResponse = answerElement.value;
          if (userResponse) {
            answerId = userResponse;
            openEndAnswer = "";
            userResponses.push(createResponse(question, answerId, openEndAnswer));
          }
          break;
        // "Multi Select"
        case 13:
          const checkboxes = document.querySelectorAll(`input[type="checkbox"][name="${question.questionId}"]:checked`);
          const selectedValues = Array.from(checkboxes).map((checkbox) => checkbox.value);
          if (selectedValues.length > 0) {
            answerId = selectedValues.join(",");
            openEndAnswer = "";
            userResponses.push(createResponse(question, answerId, openEndAnswer));
          }
          break;
        // "Country"
        case 44:
          answerId = "";
          openEndAnswer = (countryList.find((item) => item.countryId === countryId)).countryName;
          userResponses.push(createResponse(question, answerId, openEndAnswer));
          break;
        // "State"
        case 45:
          answerId = "";
          openEndAnswer = stateId;
          userResponses.push(createResponse(question, answerId, openEndAnswer));
          break;

        // "Date Picker"
        case 42:
          userResponse = answerElement.value;
          if (userResponse) {
            answerId = "";
            openEndAnswer = userResponse;
            userResponses.push(createResponse(question, answerId, openEndAnswer));
          }
          break;
        // "Descriptive Content"
        case 11:
          userResponse = answerElement.value;
          if (userResponse) {
            answerId = "";
            openEndAnswer = userResponse;
            userResponses.push(createResponse(question, answerId, openEndAnswer));
          }
          break;

        // "Autofill"
        case 28:
          answerId = "";
          openEndAnswer = age.split(" ")[0];// extract the year from the age string
          userResponses.push(createResponse(question, answerId, openEndAnswer));
          break;

        default:
          break;
      }
    });
    setIsLoading(false);
    return userResponses;
  };

  const createResponse = (question, answerId, openEndAnswer) => {
    const response = {
      customerId: user,
      questionId: question.questionId,
      answerId: answerId,
      questionTitle: question.questionTitle,
    };

    if (openEndAnswer) {
      response.openEndAnswer = openEndAnswer;
    }
    return response;
  };

  const clearFormFields = () => {
    const formElements = document.querySelectorAll("input, select");
    formElements.forEach((element) => {
      if (element.type === "checkbox" || element.type === "radio") {
        element.checked = false;
      } else {
        element.value = "";
      }
    });
  };

  const renderQuestion = (question) => {
    if (question.questionStatus === 1) {
      switch (question.questionType) {
        //  "Open End Text"
        case 15:
          return (
            <div className="common_form py-2 col-lg-6" key={question.questionId}>
              <div className="form-group">
                <label>{question.question}</label>
                {question.questionTitle === "Unique ID" ? (
                  <input type="text" id={question.questionId} value={myUUID} className="form-control w-75" placeholder="Answer here" readOnly />
                ) : (
                  <input type="text" id={question.questionId} className="form-control w-75" placeholder="Answer here" />
                )}
              </div>
            </div>
          );
        // "Single Select" 
        case 12:
          return (
            <div className="common_form pb-2 col-lg-6" key={question.questionId}>
              <div className="form-group">
                <label>{question.question}</label>
                {question.answerList.map((answer) => (
                  <div key={answer.id} className="form-check">
                    <input className="form-check-input" type="radio" id={question.questionId} name={question.questionId} value={answer.questionAnswerId} />
                    <label className="form-check-label">{answer.answer}</label>
                  </div>
                ))}
              </div>
            </div>
          );
        // "DropDown Menu"
        case 14:
          return (
            <div className="common_form pb-2 col-lg-6" key={question.questionId}>
              <div className="form-group">
                <label>{question.question}</label>
                <select className="form-select form-select-sm w-75" id={question.questionId}>
                  <option value="">Select an option</option>
                  {question.answerList.map((answer) => (
                    <option key={answer.questionAnswerId} value={answer.questionAnswerId}>
                      {answer.answer}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          );
        // "Multi Select"
        case 13:
          return (
            <div className="common_form pb-2 col-lg-6" key={question.questionId}>
              <div className="form-group">
                <label>{question.question}</label>
                {question.answerList.map((answer) => (
                  <div key={answer.questionAnswerId} className="form-check">
                    <input className="form-check-input" type="checkbox" name={question.questionId} id={question.questionId} value={answer.questionAnswerId} />
                    <label className="form-check-label">{answer.answer}</label>
                  </div>
                ))}
              </div>
            </div>
          );
        // "Country"
        case 44:
          return (
            <div className="col-lg-6">
              <div className="form-group mb-4">
                <label for="">Country</label>
                <Select className="w-75"
                  options={fillCountry()}
                  value={fillCountry().find((option) => option.value === countryId)}
                  onChange={handleCountryChange}
                  placeholder="Enter country"
                  isSearchable
                />
              </div>
            </div>
          );
        // "State"
        case 45:
          return (
            <div className="col-lg-6">
              <div className="form-group mb-4">
                <label for="">State</label>
                {stateList.length === 0 ? (
                  <input type="text" id="state" className="form-control w-75" placeholder="Enter state" value={stateId}
                    onChange={(e) => setStateId(e.target.value)} />
                ) : (
                  <Select className="w-75"
                    options={fillState()}
                    value={fillState().find((option) => option.label === stateId)}
                    onChange={(option) => setStateId(option.label)}
                    placeholder="Enter State"
                    isSearchable
                  />
                )}
              </div>
            </div>
          );
        // "Date Picker"
        case 42:
          return (
            <div className="common_form py-2 col-lg-6" key={question.questionId}>
              <div className="form-group">
                <label>{question.question}</label>
                {question.questionId === 266 ? (
                  <input type="date" id={question.questionId} className="form-control w-75" placeholder="Answer here" onChange={handleDobChange} max={new Date().toISOString().split("T")[0]} />) :
                  (
                    <input type="date" id={question.questionId} className="form-control w-75" placeholder="Answer here" max={new Date().toISOString().split("T")[0]} />)
                }
              </div>
            </div>
          );
        // "Descriptive Content"
        case 11:
          return (
            <div className="common_form py-2 col-lg-6" key={question.questionId}>
              <div className="form-group">
                <label>{question.question}</label>
                <textarea
                  id={question.questionId}
                  className="form-control w-75"
                  placeholder="Answer here"
                  rows="5"
                ></textarea>
              </div>
            </div>
          );
        // "Autofill"
        case 28:
          return (
            <div className="common_form py-2 col-lg-6" key={question.questionId}>
              <div className="form-group">
                <label>{question.question}</label>
                {question.questionId === 267 ? (
                  <input
                    type="text"
                    value={age}
                    id={question.questionId}
                    className="form-control w-75"
                    placeholder="Answer here"
                    readOnly
                  />
                ) : (
                  <input
                    type="text"
                    id={question.questionId}
                    className="form-control w-75"
                    placeholder="Answer here"
                  />
                )}
              </div>
            </div>
          );
        default:
          return null;
      }
    }
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        {isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center " style={{ zIndex: 1050 }}>
            <div className="p-5 rounded ">
              <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
            </div>
          </div>
        )}
        <div id="page_wrapper" className={`py-3 ${isLoading ? "blur" : ""}`}>
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <span className="breadcrumb_slash">/</span>
              <Link to="/panel-management">
                <li>
                  <i className="bi bi-people mx-2"></i>Panel management
                </li>
              </Link>
              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i>Add panel user
              </li>
            </ul>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <div className="row">{questions && questions.map((question) => renderQuestion(question))}</div>
            </div>

            <div className="d-flex justify-content-between p-3">
              <div className="button_group">
                <button type="button" className="btn bg-danger-subtle text-danger" onClick={() => clearFormFields()}>
                  Clear Values
                </button>
              </div>
              <div className="button_group">
                <button type="button" className="btn btn-success px-4" onClick={() => handleSubmit()}>
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPanelUser;
